import { Link } from 'react-router-dom';
import Skeleton from '../../ui/Skeleton/Skeleton';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  link?: string;
  onClick?: () => void;
  isActive?: boolean;
  isLoading?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: string;
}

export default function Breadcrumb({
  items,
  separator = '>',
}: BreadcrumbProps) {
  const getItemClassName = (item: BreadcrumbItem, isInteractive = false) =>
    `${item.isActive ? 'text-text-primary-highlight font-semibold' : 'text-text-primary-body'} text-xs 3xl:text-sm whitespace-nowrap ${
      isInteractive
        ? 'hover:text-text-primary-highlight transition-all duration-300'
        : ''
    }`;

  return (
    <nav aria-label="breadcrumb">
      <ul style={styles.breadcrumbList}>
        {items.map((item, index) => (
          <li key={index} style={styles.breadcrumbItem}>
            {item.isLoading ? (
              <Skeleton className="h-3.5 w-24" />
            ) : item.link ? (
              <Link
                to={item.link}
                onClick={item.onClick}
                className={getItemClassName(item, true)}
              >
                {item.label}
              </Link>
            ) : item.onClick ? (
              <button
                type="button"
                onClick={item.onClick}
                className={getItemClassName(item, true)}
              >
                {item.label}
              </button>
            ) : (
              <span className={getItemClassName(item)}>
                {item.label}
              </span>
            )}
            {index < items.length - 1 && (
              <span style={styles.separator}>
                <svg
                  width="12"
                  height="13"
                  viewBox="0 0 12 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.45508 10.46L7.71508 7.20004C8.10008 6.81504 8.10008 6.18504 7.71508 5.80004L4.45508 2.54004"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

// Inline styles for simplicity
const styles = {
  breadcrumbList: {
    display: 'flex',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  breadcrumbItem: {
    display: 'flex',
    alignItems: 'center',
  },

  separator: {
    margin: '0 8px',
    color: '#737373',
  },
};
